module.exports = __webpack_public_path__ + "img/home-pic-3.dcfe87b8.jpg";